import { render } from "./Importer.vue?vue&type=template&id=c7a95996&ts=true"
import script from "./Importer.vue?vue&type=script&lang=ts"
export * from "./Importer.vue?vue&type=script&lang=ts"

import exportComponent from "/root/app/github/pehuen-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__